import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 16 20"
      className="design-iconfont"
    >
      <defs>
        <path
          d="M7 12c3.859 0 7 3.14 7 7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1c0-3.86 3.141-7 7-7ZM7 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4Z"
          id="a"
        />
      </defs>
      <use xlinkHref="#a" transform="translate(1 -1)" />
    </svg>
  )
}
const UserIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
UserIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
UserIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default UserIcon
